import React, { useEffect, useState } from 'react';
import MainLayout from '../_layouts/main';
import { useLocation } from 'react-router-dom';
import { withFirebase } from '../_firebase';
import { withRouter } from 'react-router-dom';
import MaterialTable from 'material-table';
import { icons, localization } from '../_helpers/materialTableProperties';
import _ from 'lodash';
import {
    formatFirestoreTimestamp,
    getAppPublicationStatusChip,
    getMobilePlatformChip,
    mapFirestoreTimestampToMoment,
} from '../_helpers/mappers';
import moment from 'moment';
import { Description } from '@material-ui/icons';
import AppPublicationDetails from './AppPublicationDetails';

function AppPublicationsPage({ firebase }) {
    let { search } = useLocation();
    const query = new URLSearchParams(search);
    const defaultFilter = query.get('filter');

    const [publications, setPublications] = useState([]);
    const [loading, setLoading] = useState(true);

    const createdAtFieldName = 'createdAt';

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoading(true);
        firebase.getAppPublications()
            .then(data => { setPublications(data); setLoading(false); })
            .catch(() => setLoading(false));
    };

    const redirectToStoreData = (rowData) => {
        if (rowData.platformId && rowData.storeId) {
            window.open(`/platforms/${rowData.platformId}/stores?filter=${rowData.storeId}`, '_blank');
        } else {
            alert('Não é possível acessar o painel do cliente.');
        }
    };

    return (
        <MainLayout title="Publicações (expo)">
            <MaterialTable
                actions={[
                    rowData => ({
                        icon: () => <Description />,
                        tooltip: 'Ver dados da loja',
                        onClick: () => redirectToStoreData(rowData),
                    }),
                ]}
                columns={[
                    {
                        title: 'ID',
                        field: 'id',
                        defaultFilter: defaultFilter || false,
                    },
                    {
                        title: 'ID da loja',
                        field: 'storeId',
                        defaultFilter: defaultFilter || false,
                    },
                    {
                        title: 'Nome do app',
                        field: 'metadata.appName',
                    },
                    {
                        title: 'Sistema Operacional',
                        field: 'mobilePlatform',
                        render: rowData => getMobilePlatformChip(_.get(rowData, 'mobilePlatform', '')),
                    },
                    {
                        title: 'Plataforma de ecommerce',
                        field: 'platformId',
                    },
                    {
                        title: 'Ambiente',
                        field: 'buildProfile',
                        lookup: {
                            'store-production': 'Produção',
                            'store-staging': 'Homologação',
                        },
                        render: rowData => rowData.buildProfile === 'store-production' ? 'Produção' : 'Homologação',
                    },
                    {
                        title: 'Versão',
                        field: 'metadata.version',
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        defaultFilter: ['queued', 'preparing', 'building', 'built', 'submitting', 'submitted', 'failed'],
                        lookup: {
                            queued: 'Na fila',
                            preparing: 'Preparando',
                            building: 'Construindo',
                            built: 'Construído',
                            submitting: 'Enviando',
                            submitted: 'Enviado',
                            failed: 'Erro',
                            finished: 'Concluído',
                        },
                        render: rowData => getAppPublicationStatusChip(_.get(rowData, 'status', '')),
                    },
                    {
                        title: 'Data de criação',
                        field: createdAtFieldName,
                        render: rowData => formatFirestoreTimestamp(rowData[createdAtFieldName], 'DD/MM/YYYY HH:mm'),
                        customSort: (a, b) => {
                            let d1 = mapFirestoreTimestampToMoment(a[createdAtFieldName]);
                            let d2 = mapFirestoreTimestampToMoment(b[createdAtFieldName]);
                            if (!d1) d1 = moment();
                            if (!d2) d2 = moment();
                            return d1.diff(d2);
                        },
                        defaultSort: 'desc',
                    },
                ]}
                data={publications}
                detailPanel={rowData => <AppPublicationDetails publication={rowData} onDataUpdate={getData} />}
                icons={icons}
                isLoading={loading}
                localization={localization}
                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                options={{
                    actionsColumnIndex: -1,
                    filtering: true,
                    pageSize: 10,
                }}
                title=""
            />
        </MainLayout>
    );
}

export default withRouter(withFirebase(AppPublicationsPage));
